import { render } from "./SpanBlocksSwiper.vue?vue&type=template&id=317050a0&scoped=true"
import script from "./SpanBlocksSwiper.vue?vue&type=script&lang=js"
export * from "./SpanBlocksSwiper.vue?vue&type=script&lang=js"

import "./SpanBlocksSwiper.vue?vue&type=style&index=0&id=317050a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-317050a0"]])

export default __exports__